import { ImagesSkusChevronDownSvg } from '@/assets/images_skus.assets';
import DefaultButton from '@/components/common/default/DefaultButton';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { SkusEnum } from '@/types/translations/SkusEnum';
import { Checkbox, Field, Label, Transition } from '@headlessui/react';
import Image from 'next/image';
import { Fragment, useState } from 'react';
import { FaCheck } from 'react-icons/fa';
import { useMenu } from 'react-instantsearch';

export default function SkusMobileAlgoliaShowMenuFilter() {
  const { translate } = useTypedTranslation<SkusEnum>('skus');

  const [showTypeItems, setShowTypeItems] = useState(false);

  const menuCategoryName = useMenu({
    attribute: 'category.name',
  });

  return (
    <li>
      <DefaultButton
        className="tw-font-plusJakartaSans !tw-text-base tw-font-semibold tw-text-textBlack tw-flex tw-items-center tw-justify-between tw-w-full"
        onClick={() => setShowTypeItems((prev) => !prev)}
      >
        {translate(SkusEnum['type'])}
        <Image
          src={ImagesSkusChevronDownSvg}
          width={5.59}
          height={12}
          alt="Chevron Down"
        />
      </DefaultButton>

      <Transition
        as={Fragment}
        show={showTypeItems}
        enter="transition-opacity duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-300"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <ul className="tw-p-0 tw-mt-4 tw-flex tw-flex-col tw-gap-4 tw-border tw-border-custom-gray tw-border-solid tw-border-r-0 tw-border-l-0 tw-border-t-0 tw-pb-4">
          {menuCategoryName.items.map((item) => (
            <Field
              as="li"
              className="tw-flex tw-items-center tw-gap-2"
              key={item.value}
            >
              <Checkbox
                id={`checkbox-${item.label}`}
                name={`checkbox-${item.label}`}
                checked={item.isRefined}
                onChange={() => menuCategoryName.refine(item.value)}
                disabled={!menuCategoryName.canRefine}
                className="tw-group tw-flex tw-size-6 tw-rounded-md tw-border-2 tw-bg-white tw-border-solid tw-border-custom-gray tw-items-center tw-justify-center data-[checked]:tw-bg-main"
              >
                <FaCheck className="group-data-[checked]:tw-text-white tw-text-transparent tw-text-xs" />
              </Checkbox>
              <Label
                className="tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-text-text"
                htmlFor={`checkbox-${item.label}`}
              >
                {item.label}{' '}
                <span className="tw-bg-baby-blue tw-font-plusJakartaSans tw-font-medium tw-text-sm tw-text-textBlack tw-rounded-full tw-px-3 tw-py-1">
                  {item.count}
                </span>
              </Label>
            </Field>
          ))}
        </ul>
      </Transition>
    </li>
  );
}
